import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { taskRoutingModule } from './task-routing.module';
import { MatTabsModule } from '@angular/material/tabs';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CreateTaskComponent } from './create-task/create-task.component';
import { MatCardModule } from '@angular/material/card';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { TaskComponent } from './task.component';
import { TaskDashboardComponent } from './task-dashboard/task-dashboard.component';
import { AddPiComponent } from './add-pi/add-pi.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {MatBadgeModule} from '@angular/material/badge';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { NgGanttEditorModule } from 'ng-gantt';
import { GanttViewComponent } from './gantt-view/gantt-view.component';
import { TaskReminderComponent } from './task-detail/task-reminder/task-reminder.component';
import { TaskAssignComponent } from './task-detail/task-assign/task-assign.component';
import { TaskScheduleByComponent } from './task-detail/task-schedule-by/task-schedule-by.component';
import { TaskAttachCccComponent } from './task-detail/task-attach-ccc/task-attach-ccc.component' 
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { ApiEndPointsTask } from './common/apiUrls/api-end-points-task';
import { TaskService } from './services/task.services';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
  declarations: [TaskDashboardComponent, CreateTaskComponent, TaskDetailComponent, TaskComponent, AddPiComponent, GanttViewComponent, TaskReminderComponent, TaskAssignComponent, TaskScheduleByComponent, TaskAttachCccComponent,
    ],
  imports: [
    NgSelectModule,
    CommonModule,
    taskRoutingModule,
    MatTabsModule,
    FlexLayoutModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatRadioModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTableModule,
    DragDropModule,
    ScrollingModule,
    MatCardModule,
    MatBadgeModule,
    MatProgressBarModule,
    NgGanttEditorModule,
    NgxMaterialTimepickerModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    SharedModule
  ],
  providers:[
    ApiEndPointsTask,
    TaskService,
    LoaderService,   
   
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
  ]
})
export class TaskModule { }
